import React from 'react';
import axios from "../../containers/api";
import {Card, CardBody, CardTitle,Alert, Badge, Button, FormGroup, Input, Label} from "reactstrap";
import {showCatchError, toEnglishNumbers} from "../../helpers/Utils";
import { Colxx} from "../../components/common/CustomBootstrap";
import {Table} from "../../components/table/Table";
class DriverInformation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
           
            errors: [],
            oneDriver: this.props && this.props.driver,
            mobile: this.props && this.props.driver.mobile,
            DriverFrieghter:[]
        }
    }

    ChangePhoneNumber = () => {
        this.props.closeSweetAlert();
        if (this.state.mobile.length < 11) {
            this.props.showAlert("لطفا شماره موبایل را صحيح وارد كنيد ", "error");
        } else {
            this.props.showSpinner();
            const request = {
                Mobile: toEnglishNumbers(this.state.mobile),
                DriverId:   (this.state.oneDriver.id),
                UserName: toEnglishNumbers(this.state.oneDriver.nationalId),
            }
            axios.post('api/v1/drivers/ChangePhoneNumber', request)
                .then((res) => {
                    this.props.hideSpinner();
                    this.props.showAlert(res.data.message, "success");;
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        }
    };

    
    

    render() {
        return (
            <div className="d-flex flex-column w-100">
                {this.state.errors.length === 0 ?
                    null
                    :
                    <div>
                        {(this.state.errors.map((error, i) => {
                            return (
                                <Alert color="danger" key={i}>{error}</Alert>
                            )
                        }))}
                    </div>
                }

                <div className="d-flex flex-md-row flex-column justify-content-center align-items-end flex-wrap w-100 mt-5">
                
                    
                    <FormGroup className="w-md-20 w-100 px-1">
                        <Label>شماره موبایل</Label>
                        <Input value={this.state.mobile}
                            onChange={(e) => this.setState({ mobile: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                    </FormGroup>
                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2"
                            onClick={() => this.props.showSweetAlert("آیا از تغییر شماره موبايل این راننده مطمئن هستید؟", "", "warning", this.ChangePhoneNumber)}>
                            ویرایش موبایل
                        </Button>
                    </FormGroup>
                </div>
                 
            </div>
        );
    }
}

export default DriverInformation;